"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddMessage = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactMentions = require("react-mentions");

var _blocks = require("@bueno/blocks");

var Elements = _interopRequireWildcard(require("./AddMessage.styles"));

var _context = require("../context");

var _hooks = require("../hooks");

var _AddFile = require("../../components/AddFile");

var _core = require("@lingui/core");

function displayTransform(_id, display) {
  return `@${display}`;
}

const AddMessage = ({
  actionId
}) => {
  const {
    attachment,
    messageStatus,
    message,
    mentionsList,
    handleAttachment,
    handleRemoveAttachment,
    handleAddMessage,
    handleChange,
    error
  } = (0, _hooks.useMessage)(actionId);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Elements.Container, null, /*#__PURE__*/React.createElement(Elements.MentionWrapper, null, /*#__PURE__*/React.createElement(_reactMentions.MentionsInput, {
    className: "Mentions",
    onChange: handleChange,
    value: message.value,
    placeholder: _core.i18n._({
      id: 'add_message.message_placeholder',
      message: `Enter your comment...`
    })
  }, /*#__PURE__*/React.createElement(_reactMentions.Mention, {
    trigger: "@",
    markup: "@[__display__](__type__:__id__)",
    data: mentionsList,
    displayTransform: displayTransform
  }))), /*#__PURE__*/React.createElement(Elements.Controls, null, /*#__PURE__*/React.createElement(_AddFile.AddFile, {
    id: "CommentAttachment",
    onChange: handleAttachment,
    onCancel: handleRemoveAttachment,
    fileName: attachment === null || attachment === void 0 ? void 0 : attachment.name,
    label: _core.i18n._({
      id: 'add_message.attach_file_button',
      message: `Attach file`
    })
  }), /*#__PURE__*/React.createElement(_blocks.Button, {
    wafer: true,
    appearance: "solid",
    disabled: message.value.length < 1 || messageStatus === _context.Status.loading,
    onClick: handleAddMessage
  }, _core.i18n._({
    id: 'add_message.add_comment_button',
    message: `Add Comment`
  })))), error !== undefined && /*#__PURE__*/React.createElement(Elements.ServerError, null, /*#__PURE__*/React.createElement(_blocks.ErrorOutline, {
    small: true
  }), error));
};

exports.AddMessage = AddMessage;